var map = {
	"./de/btn-back.png": "ff83",
	"./en/btn-back.png": "5a6l",
	"./es/btn-back.png": "oKJS",
	"./fr/btn-back.png": "9NVa",
	"./ja/btn-back.png": "Xunh",
	"./ko/btn-back.png": "xxJP",
	"./pt/btn-back.png": "d938",
	"./ru/btn-back.png": "UQgl",
	"./th/btn-back.png": "tAn8",
	"./zh-Hant/btn-back.png": "pleP"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kq2x";